import { useCallback } from 'react'

export interface StylesProps {
  checkboxSelectionMode: 'all' | 'parentOnly' | 'childOnly'
}

export function useStyles({ checkboxSelectionMode }: StylesProps) {
  // Custom row styling
  const getRowClassName = useCallback((params: any) => {
    if (params && params.row) {
      if (params.row.isGroupRow) return 'group-row'
      if (params.row.isChildRow) return 'child-row'
    }
    return ''
  }, [])

  // Create CSS classes based on checkbox selection mode
  const getCheckboxVisibilityStyles = useCallback(() => {
    if (checkboxSelectionMode === 'all') return {}

    if (checkboxSelectionMode === 'parentOnly') {
      return {
        '& .child-row .MuiDataGrid-checkboxInput': {
          display: 'none'
        }
      }
    }

    if (checkboxSelectionMode === 'childOnly') {
      return {
        '& .group-row .MuiDataGrid-checkboxInput': {
          display: 'none'
        }
      }
    }

    return {}
  }, [checkboxSelectionMode])

  // Determine if a row should have a checkbox based on the selection mode
  const isRowSelectable = useCallback(
    (params: any) => {
      if (!params || !params.row) return false

      const { row } = params

      switch (checkboxSelectionMode) {
        case 'parentOnly':
          return row.isGroupRow === true
        case 'childOnly':
          return row.isChildRow === true
        case 'all':
        default:
          return true
      }
    },
    [checkboxSelectionMode]
  )

  return { getRowClassName, getCheckboxVisibilityStyles, isRowSelectable }
}
